import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { Suspense } from "react";
import { PROJECT } from "@/app/capabilities/permissions";
import { toolExecutionsQueryOptions } from "@/app/tool-executions/api/get-tool-executions";
import { ToolExecutionsSkeleton } from "@/app/tool-executions/components/tool-executions-skeleton";
import { ToolExecutionsList } from "@/app/tool-executions/list";
import {
  pickFilters,
  toolExecutionsSearchDefaults,
  toolExecutionsSearchSchema,
} from "@/app/tool-executions/search";
import { RouteErrorBoundary } from "@/components/custom/router/route-error-boundary";
import { requireProjectPermission } from "@/lib/route-guards";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/tool-executions"
)({
  validateSearch: toolExecutionsSearchSchema,
  search: {
    middlewares: [stripSearchParams(toolExecutionsSearchDefaults)],
  },
  errorComponent: RouteErrorBoundary,
  component: () => (
    <Suspense fallback={<ToolExecutionsSkeleton />}>
      <ToolExecutionsList />
    </Suspense>
  ),
  beforeLoad: async (ctx) => {
    // The history itself is readable by anyone holding a role on the project;
    // only the recorded inputs and outputs take admin authority, and the sheet
    // gates those on `executions.read` where they are requested.
    await requireProjectPermission(ctx, PROJECT.executions.metadataRead);

    ctx.context.queryClient.prefetchQuery(
      toolExecutionsQueryOptions({
        scope: ctx.params,
        filters: pickFilters(ctx.search),
        limit: ctx.search.limit,
        offset: ctx.search.offset,
      })
    );
  },
  loader: () => ({ crumb: "Tool Executions" }),
});
